import React from 'react';
import { CopyrightIcon } from '../../icons';
import { MainFooter as MainFooterStyled, MainFooterParagraph, } from './LoginWrapper.styles';
import { DateTime } from 'luxon';
export default function MainFooter() {
    return (React.createElement(MainFooterStyled, null,
        React.createElement(MainFooterParagraph, null,
            React.createElement(CopyrightIcon, null),
            " ",
            DateTime.now().year,
            " Autodesk, All Rights Reserved"),
        React.createElement(MainFooterParagraph, null,
            React.createElement("a", { href: "https://www.autodesk.com/company/terms-of-use/en/general-terms" }, "Terms & Conditions"),
            "|",
            React.createElement("a", { href: "https://www.autodesk.com/company/legal-notices-trademarks/privacy-statement" }, "Privacy Statement"))));
}
